// src/data/productsData.js
export const productsData = {
  "products": [
    // ========================================
    // ACRYLIC PRODUCTS (TOP)
    // ========================================
    {
      "id": 38,
      "name": "Premium Acrylic Sheet - Clear",
      "category": "Acrylic",
      "description": "High-quality clear acrylic sheet with excellent transparency and UV stability. Perfect for signage, displays, and glazing.",
      "price": "₹120/sq.ft",
      "thickness": "3mm",
      "size": "8×4 ft",
      "color": "Clear",
      "features": ["High Transparency", "UV Stable", "Lightweight", "Weather Resistant"],
      "image": "https://i.postimg.cc/63fxN8Yq/NX-6H-ACRYLIC-page-0001-02.png",
      "inStock": true
    },
    {
      "id": 39,
      "name": "Colored Acrylic Sheet - Frosted White",
      "category": "Acrylic",
      "description": "Elegant frosted white acrylic sheet perfect for partitions, lighting fixtures, and decorative applications.",
      "price": "₹135/sq.ft",
      "thickness": "3mm",
      "size": "8×4 ft",
      "color": "Frosted White",
      "features": ["Soft Light Diffusion", "Modern Look", "Scratch Resistant", "Easy to Fabricate"],
      "image": "https://i.postimg.cc/PxQnkC2N/NX-6H-ACRYLIC-page-0001-03.png",
      "inStock": true
    },
    {
      "id": 40,
      "name": "Premium Acrylic - Mirror Finish",
      "category": "Acrylic",
      "description": "High-gloss mirror finish acrylic sheet with reflective surface. Ideal for decorative panels and modern interiors.",
      "price": "₹160/sq.ft",
      "thickness": "3mm",
      "size": "8×4 ft",
      "color": "Silver Mirror",
      "features": ["Mirror Finish", "High Gloss", "Shatter Resistant", "Lightweight"],
      "image": "https://i.postimg.cc/tJRQR9MR/NX-6H-ACRYLIC-page-0001-04.png",
      "inStock": true
    },
    {
      "id": 41,
      "name": "Backlit Acrylic Sheet - Milky White",
      "category": "Acrylic",
      "description": "Special milky white acrylic sheet designed for backlighting applications. Perfect for light boxes and LED displays.",
      "price": "₹150/sq.ft",
      "thickness": "3mm",
      "size": "8×4 ft",
      "color": "Milky White",
      "features": ["Excellent Light Diffusion", "LED Compatible", "Even Illumination", "UV Stable"],
      "image": "https://i.postimg.cc/cC1y1dbx/NX-6H-ACRYLIC-page-0001-05.png",
      "inStock": true
    },
    {
      "id": 42,
      "name": "Premium Acrylic Sheet - Black",
      "category": "Acrylic",
      "description": "Solid black acrylic sheet with deep color and glossy finish. Perfect for modern furniture, displays, and signage.",
      "price": "₹140/sq.ft",
      "thickness": "3mm",
      "size": "8×4 ft",
      "color": "Black",
      "features": ["Deep Color", "Glossy Finish", "Weather Resistant", "Versatile Use"],
      "image": "https://i.postimg.cc/Gt3w3b5h/NX-6H-ACRYLIC-page-0001-06.png",
      "inStock": true
    },

    // ========================================
    // VENEER PRODUCTS
    // ========================================
    {
      "id": 4,
      "name": "Burma Teak Wood Veneer",
      "category": "Veneer",
      "description": "Premium 4mm thick Burma Teak veneer. Perfect for luxury furniture, wall paneling, and interior decoration.",
      "price": "₹85/sq.ft",
      "thickness": "4mm",
      "size": "8×4 ft / 10×4 ft",
      "color": "Burma Teak",
      "features": ["Natural Wood Grain", "4mm Thickness", "Premium Quality", "Ready to Use"],
      "image": "https://framerusercontent.com/images/MOFREwApbdWmkPriy0iOttBCfJo.png",
      "inStock": true
    },
    {
      "id": 5,
      "name": "Santos Rosewood Veneer",
      "category": "Veneer",
      "description": "Exotic Santos rosewood veneer with rich dark brown color and striking grain patterns. 4mm thickness.",
      "price": "₹95/sq.ft",
      "thickness": "4mm",
      "size": "8×4 ft / 10×4 ft",
      "color": "Santos Rosewood",
      "features": ["Exotic Wood", "Rich Color", "Striking Grain Pattern", "4mm Thickness"],
      "image": "https://tabledesigns.com/wp-content/uploads/2020/12/Santos-Rosewood-Veneer-Self-Edge-02.jpg",
      "inStock": true
    },
    {
      "id": 6,
      "name": "White Ash Veneer",
      "category": "Veneer",
      "description": "Light-colored White Ash veneer with prominent grain. Ideal for modern and Scandinavian interior designs.",
      "price": "₹75/sq.ft",
      "thickness": "4mm",
      "size": "8×4 ft / 10×4 ft",
      "color": "White Ash",
      "features": ["Light Color", "Prominent Grain", "Modern Look", "4mm Thickness"],
      "image": "https://5.imimg.com/data5/SELLER/Default/2022/8/ZB/JS/AR/37882387/white-ash-veneer.jpg",
      "inStock": true
    },
    {
      "id": 7,
      "name": "Red Oak Veneer",
      "category": "Veneer",
      "description": "Warm reddish-brown Red Oak veneer with beautiful straight grain. Perfect for traditional interiors.",
      "price": "₹80/sq.ft",
      "thickness": "4mm",
      "size": "8×4 ft / 10×4 ft",
      "color": "Red Oak",
      "features": ["Warm Color", "Straight Grain", "Traditional Look", "4mm Thickness"],
      "image": "https://image.made-in-china.com/202f0j00sgJkEbaFhHzI/High-Quality-Red-Oak-Veneered-MDF-Board.webp",
      "inStock": true
    },
    {
      "id": 8,
      "name": "Succapira Veneer",
      "category": "Veneer",
      "description": "Exclusive Succapira veneer with unique golden-brown color and distinctive grain patterns.",
      "price": "₹110/sq.ft",
      "thickness": "4mm",
      "size": "8×4 ft / 10×4 ft",
      "color": "Succapira",
      "features": ["Exclusive Design", "Golden-Brown Color", "Unique Grain", "4mm Thickness"],
      "image": "https://naturalveneers.s3.ap-south-1.amazonaws.com/new_site_images/front/0_68207100_1563452529.jpg",
      "inStock": true
    },
    {
      "id": 9,
      "name": "Designer Wood Veneer Collection",
      "category": "Veneer",
      "description": "Premium designer veneer collection with multiple pattern options. Perfect for accent walls and luxury furniture.",
      "price": "₹125/sq.ft",
      "thickness": "4mm",
      "size": "8×4 ft / 10×4 ft",
      "color": "Multiple Options",
      "features": ["Designer Patterns", "Premium Finish", "Multiple Options", "4mm Thickness"],
      "image": "https://naturalveneers.s3.ap-south-1.amazonaws.com/asset/public/images/natural-wood-veneers/Veneered-Fluted-Panels.webp",
      "inStock": true
    },

    // ========================================
    // FLUTED LOUVERS PRODUCTS
    // ========================================
    {
      "id": 33,
      "name": "Fluted Panels - Natural Wood",
      "category": "Fluted Louvers",
      "description": "Elegant fluted panels with natural wood finish. Creates stunning vertical lines adding depth and texture to walls.",
      "price": "₹250/sq.ft",
      "thickness": "18mm",
      "color": "Natural Wood",
      "features": ["Deep Flutes", "Natural Texture", "Premium Quality", "Acoustic Benefits"],
      "image": "https://nextleveldecor.in/cdn/shop/files/korealouvers_2F_5B_23438886_20_5D_01.jpg?v=1753111264",
      "inStock": true
    },
    {
      "id": 34,
      "name": "Designer Fluted Panels - Dark Walnut",
      "category": "Fluted Louvers",
      "description": "Premium designer fluted panels in rich dark walnut. Perfect for luxury interiors, feature walls, and high-end commercial spaces.",
      "price": "₹280/sq.ft",
      "thickness": "18mm",
      "color": "Dark Walnut",
      "features": ["Luxury Finish", "Rich Color", "Designer Pattern", "Durable"],
      "image": "https://5.imimg.com/data5/ANDROID/Default/2020/10/QP/XL/RC/32174847/product-jpeg-500x500.jpg",
      "inStock": true
    },
    {
      "id": 35,
      "name": "Fluted Wall Panels - White Oak",
      "category": "Fluted Louvers",
      "description": "Elegant white oak fluted panels adding sophistication to any space. Ideal for modern and Scandinavian interiors.",
      "price": "₹265/sq.ft",
      "thickness": "18mm",
      "color": "White Oak",
      "features": ["Scandinavian Style", "Light Color", "Vertical Lines", "Easy Installation"],
      "image": "https://image.made-in-china.com/2f0j00ynikbUGFMIcO/Wood-Grain-Designs-WPC-Fluted-Wall-Panels-Wood-PVC-Louvers-Panel-Wall.jpg",
      "inStock": true
    },
    {
      "id": 36,
      "name": "Premium Fluted MDF Panels",
      "category": "Fluted Louvers",
      "description": "High-quality fluted MDF panels with consistent pattern and smooth finish. Perfect for painting or natural look.",
      "price": "₹195/sq.ft",
      "thickness": "15mm",
      "color": "Primed White",
      "features": ["Ready to Paint", "Smooth Surface", "Consistent Pattern", "Cost Effective"],
      "image": "https://i.postimg.cc/t4sbVCC3/FLUTED-LOUVERS-NEW-page-0001-03.png",
      "inStock": true
    },
    {
      "id": 37,
      "name": "Architectural Fluted Panels - Charcoal",
      "category": "Fluted Louvers",
      "description": "Bold architectural fluted panels in charcoal finish. Creates dramatic statement walls for contemporary spaces.",
      "price": "₹240/sq.ft",
      "thickness": "18mm",
      "color": "Charcoal",
      "features": ["Bold Design", "Dramatic Effect", "Commercial Grade", "UV Stable"],
      "image": "https://i.postimg.cc/cJYNX93h/FLUTED-LOUVERS-NEW-page-0001-04.png",
      "inStock": true
    },

    // ========================================
    // LOUVERS PRODUCTS
    // ========================================
    {
      "id": 28,
      "name": "Modern Louvers Panel - White",
      "category": "Louvers",
      "description": "Elegant modern louvers panel for interior wall cladding, facade decoration, and ceiling applications. Creates stunning visual effects with parallel grooves.",
      "price": "₹180/sq.ft",
      "thickness": "12mm",
      "size": "8×4 ft",
      "color": "White",
      "features": ["UV Stable", "Easy to Install", "Low Maintenance", "Modern Aesthetic"],
      "image": "https://nextleveldecor.in/cdn/shop/files/korealouvers_2F_5B_20_23438883_5D_01.jpg?v=1753111226",
      "inStock": true
    },
    {
      "id": 29,
      "name": "Premium Wood Louvers - Teak Finish",
      "category": "Louvers",
      "description": "Premium wood finish louvers panel with rich teak color. Perfect for accent walls, headboards, and feature panels.",
      "price": "₹220/sq.ft",
      "thickness": "15mm",
      "size": "8×4 ft",
      "color": "Teak",
      "features": ["Wood Texture", "Rich Finish", "Durable", "Easy Installation"],
      "image": "https://treeplast.in/wp-content/uploads/2025/11/residential-balcony-wpc-partition-privacy-screen.webp",
      "inStock": true
    },
    {
      "id": 30,
      "name": "Decorative Louvers - Walnut",
      "category": "Louvers",
      "description": "Sophisticated walnut finish louvers adding warmth and elegance to any interior space. Ideal for modern and contemporary designs.",
      "price": "₹210/sq.ft",
      "thickness": "12mm",
      "size": "8×4 ft",
      "color": "Walnut",
      "features": ["Warm Tone", "Elegant Design", "Scratch Resistant", "Easy Cleaning"],
      "image": "https://static.wixstatic.com/media/08ea8a_32727ecfa9f74ce59f6b3cc7a484033b~mv2.jpg/v1/fill/w_966,h_966,al_c,q_85,enc_avif,quality_auto/08ea8a_32727ecfa9f74ce59f6b3cc7a484033b~mv2.jpg",
      "inStock": true
    },
    {
      "id": 31,
      "name": "Architectural Louvers - Oak",
      "category": "Louvers",
      "description": "Architectural grade louvers with oak finish for commercial and residential applications. Creates dramatic shadow effects.",
      "price": "₹195/sq.ft",
      "thickness": "15mm",
      "size": "8×4 ft",
      "color": "Oak",
      "features": ["Architectural Grade", "Shadow Effect", "Commercial Quality", "UV Protected"],
      "image": "https://metalmaster.ae/wp-content/uploads/elementor/thumbs/3T1A6280-scaled-r9gwz5c31d83qowbijjrgcd4dr45r1cex0w985ls0g.webp",
      "inStock": true
    },
    {
      "id": 32,
      "name": "Minimalist Louvers - Grey",
      "category": "Louvers",
      "description": "Contemporary minimalist louvers in sophisticated grey. Perfect for modern interiors, offices, and commercial spaces.",
      "price": "₹175/sq.ft",
      "thickness": "12mm",
      "size": "8×4 ft",
      "color": "Grey",
      "features": ["Contemporary Design", "Neutral Color", "Versatile Use", "Modern Look"],
      "image": "https://theroots.in/pub/media/catalog/product/cache/cf3f2243ef4940fd5c66f2ff035145ac/1/5/1537_a.jpg",
      "inStock": true
    },

    // ========================================
    // PLYWOOD PRODUCTS
    // ========================================
    {
      "id": 18,
      "name": "ULTRA PRIME Plywood (Cold Water Proof)",
      "category": "Plywood",
      "description": "Premium ULTRA PRIME series plywood. Cold water proof with superior strength for furniture and interiors.",
      "price": "₹95/sq.ft",
      "thickness": "6mm, 9mm, 12mm, 16mm, 19mm",
      "size": "8×4 ft",
      "color": "Natural Teak",
      "features": ["Cold Water Proof", "Termite Resistant", "ULTRA PRIME Series"],
      "image": "https://shamsrayan.com/wp-content/uploads/2025/03/commercial-plywood-01.png",
      "inStock": true
    },
    {
      "id": 19,
      "name": "Diamond Club Plywood - 710 Grade (Boiling Water Proof)",
      "category": "Plywood",
      "description": "Premium Diamond Club series plywood with IS 710 certification. 100% boiling water proof for kitchens, bathrooms, and exterior use.",
      "price": "₹185/sq.ft",
      "thickness": "6mm, 9mm, 12mm, 16mm, 19mm",
      "size": "8×4 ft",
      "color": "Dark Teak",
      "features": ["IS 710 Certified", "Boiling Water Proof", "Marine Grade", "Diamond Club Series"],
      "image": "https://www.greenply.com:5001/originalfile1770630129610-6681.jpg",
      "inStock": true
    },
    {
      "id": 20,
      "name": "ULTRA PRIME - 6mm Plywood",
      "category": "Plywood",
      "description": "ULTRA PRIME series 6mm plywood ideal for cabinet backs, drawer bottoms, and lightweight applications.",
      "price": "₹55/sq.ft",
      "thickness": "6mm",
      "size": "8×4 ft",
      "color": "Natural",
      "features": ["Lightweight", "Smooth Surface", "IS 303 Certified", "6mm Thickness"],
      "image": "https://5.imimg.com/data5/SELLER/Default/2022/11/ZC/MY/PK/27475780/hardwood-plywood-500x500-500x500-250x250.jpg",
      "inStock": true
    },
    {
      "id": 21,
      "name": "Diamond Club - 19mm Plywood",
      "category": "Plywood",
      "description": "Heavy duty Diamond Club 19mm plywood for structural applications, shelving, and heavy furniture.",
      "price": "₹220/sq.ft",
      "thickness": "19mm",
      "size": "8×4 ft",
      "color": "Dark Teak",
      "features": ["IS 710 Certified", "Boiling Water Proof", "Heavy Duty", "19mm Thickness"],
      "image": "https://www.greenply.com:5001/originalfile1773664220970-1253.jpeg",
      "inStock": true
    },
    {
      "id": 22,
      "name": "Commercial Plywood - 303 Grade",
      "category": "Plywood",
      "description": "Standard commercial plywood with IS 303 certification. Perfect for general furniture and interior work.",
      "price": "₹75/sq.ft",
      "thickness": "6mm, 9mm, 12mm, 16mm, 19mm",
      "size": "8×4 ft",
      "color": "Natural",
      "features": ["IS 303 Certified", "Semi Water Proof", "Commercial Grade", "Economical"],
      "image": "https://www.zadinteriors.com/blog/wp-content/uploads/2020/08/303-and-710-Grade-Plywood.jpg",
      "inStock": true
    },
    {
      "id": 23,
      "name": "Marine Plywood - 710 Grade",
      "category": "Plywood",
      "description": "Premium marine grade plywood with IS 710 certification. 100% boiling water proof for extreme conditions.",
      "price": "₹195/sq.ft",
      "thickness": "12mm, 16mm, 19mm",
      "size": "8×4 ft",
      "color": "Dark Teak",
      "features": ["IS 710 Certified", "Boiling Water Proof", "Marine Grade", "Fungal Resistant"],
      "image": "https://i.postimg.cc/Kzmfg2VD/Gemini-Generated-Image-nkx0sunkx0sunkx0.jpg",
      "inStock": true
    },
    {
      "id": 24,
      "name": "Shuttering Plywood",
      "category": "Industrial",
      "description": "High-strength plywood for concrete formwork and construction shuttering. Reusable multiple times.",
      "price": "₹95/sq.ft",
      "thickness": "12mm, 15mm, 18mm",
      "size": "8x4 ft",
      "color": "Brown",
      "features": ["High Strength", "Water Resistant Film", "Reusable up to 8-10 times"],
      "image": "https://i.postimg.cc/qMHc5npJ/Gemini-Generated-Image-tqpn7jtqpn7jtqpn.jpg",
      "inStock": true
    },
    {
      "id": 25,
      "name": "Flexible / Bendable Plywood",
      "category": "Specialty",
      "description": "Curve-friendly plywood for creating arched doors, curved furniture, and creative architectural designs.",
      "price": "₹195/sq.ft",
      "thickness": "4mm, 6mm",
      "size": "8x4 ft",
      "color": "Natural",
      "features": ["Bends up to 90°", "Smooth Surface", "Crack Resistant"],
      "image": "https://res.cloudinary.com/materials-market/image/upload/q_auto,f_auto/assets//product-images-final/Bendy+Flexi+Plywood+Photo+2REVA.jpg?w=400&h=300&fit=crop",
      "inStock": true
    },
    {
      "id": 26,
      "name": "Block Board",
      "category": "Commercial",
      "description": "Solid core blockboard with poplar strips. Perfect for shelves, partitions, tables, and heavy-duty furniture.",
      "price": "₹110/sq.ft",
      "thickness": "16mm, 19mm, 25mm",
      "size": "8x4 ft",
      "color": "Light Teak",
      "features": ["Solid Core", "Screw Holding Capacity", "Warp Resistant"],
      "image": "https://www.duroply.in/blog/wp-content/uploads/2022/07/3-1024x576.jpg?w=400&h=300&fit=crop",
      "inStock": true
    },
    {
      "id": 27,
      "name": "Teak Wood Plywood",
      "category": "Premium",
      "description": "100% genuine teak wood face plywood for luxury furniture and high-end interiors.",
      "price": "₹350/sq.ft",
      "thickness": "12mm, 18mm, 25mm",
      "size": "8x4 ft",
      "color": "Golden Teak",
      "features": ["Genuine Teak Veneer", "Luxury Finish", "Premium Quality"],
      "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSWX4G6MUZ_vgNCJgdARiAtIrWCBLHYan8d4g&s",
      "inStock": false
    },

    // ========================================
    // LAMINATE PRODUCTS
    // ========================================
    {
      "id": 10,
      "name": "Premium Laminate - 0.72mm",
      "category": "Laminates",
      "description": "High-quality decorative laminate with 0.72mm thickness. Scratch and stain resistant for long-lasting beauty.",
      "price": "₹45/sq.ft",
      "thickness": "0.72mm",
      "size": "8×4 ft",
      "color": "Multiple Options",
      "features": ["Scratch Resistant", "Stain Resistant", "Easy to Clean", "0.72mm Thickness"],
      "image": "https://5.imimg.com/data5/SELLER/Default/2022/7/YI/VI/PP/3938886/0-72-mm-pinklam-sunmica-laminate-sheets-500x500.jpg",
      "inStock": true
    },
    {
      "id": 11,
      "name": "Premium Laminate - 0.8mm",
      "category": "Laminates",
      "description": "Durable decorative laminate with 0.8mm thickness. Ideal for kitchen cabinets, wardrobes, and furniture.",
      "price": "₹55/sq.ft",
      "thickness": "0.8mm",
      "size": "8×4 ft",
      "color": "Multiple Options",
      "features": ["High Durability", "UV Resistant", "Moisture Resistant", "0.8mm Thickness"],
      "image": "https://media.licdn.com/dms/image/v2/D5612AQFFqHdPvOXvfA/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1706860932387?e=2147483647&v=beta&t=R51uiqQi5Flz39Kn_HzF_nTxT8BMvnYMD1VF1zFHWJE",
      "inStock": true
    },
    {
      "id": 12,
      "name": "Premium Laminate - 1mm",
      "category": "Laminates",
      "description": "Heavy-duty laminate with 1mm thickness. Perfect for high-traffic areas and commercial applications.",
      "price": "₹65/sq.ft",
      "thickness": "1mm",
      "size": "8×4 ft",
      "color": "Multiple Options",
      "features": ["Heavy Duty", "Impact Resistant", "Commercial Grade", "1mm Thickness"],
      "image": "https://www.greenply.com:5001/originalfile1735285197909-9045.jpg",
      "inStock": true
    },
    {
      "id": 13,
      "name": "Premium Laminate - 1.25mm",
      "category": "Laminates",
      "description": "Ultra-premium thick laminate for luxury applications. Maximum durability and premium finish.",
      "price": "₹85/sq.ft",
      "thickness": "1.25mm",
      "size": "8×4 ft",
      "color": "Multiple Options",
      "features": ["Ultra Premium", "Maximum Durability", "Luxury Finish", "1.25mm Thickness"],
      "image": "https://5.imimg.com/data5/JG/TT/RG/SELLER-37085743/liner-laminates.jpg",
      "inStock": true
    },

    // ========================================
    // FLUSH DOOR PRODUCTS
    // ========================================
    {
      "id": 14,
      "name": "Water Proof Flush Door - 30mm",
      "category": "Flush Doors",
      "description": "Premium water proof flush door with 30mm thickness. Perfect for bathrooms, kitchens, and exterior use.",
      "price": "₹3,500/piece",
      "thickness": "30mm",
      "size": "Custom sizes available",
      "color": "Natural Teak",
      "features": ["100% Water Proof", "Termite Proof", "Warp Resistant", "30mm Thickness"],
      "image": "https://m.media-amazon.com/images/I/71qqeqXbbCL.jpg",
      "inStock": true
    },
    {
      "id": 15,
      "name": "Water Proof Flush Door - 32mm",
      "category": "Flush Doors",
      "description": "Heavy duty water proof flush door with 32mm thickness. Superior strength for main doors and high-traffic areas.",
      "price": "₹3,900/piece",
      "thickness": "32mm",
      "size": "Custom sizes available",
      "color": "Natural Teak / Walnut",
      "features": ["100% Water Proof", "Heavy Duty", "Sound Insulation", "32mm Thickness"],
      "image": "https://5.imimg.com/data5/ANDROID/Default/2021/7/YE/SX/WA/90111921/product-jpeg-500x500.jpeg",
      "inStock": true
    },
    {
      "id": 16,
      "name": "Semi Water Proof Flush Door - 30mm",
      "category": "Flush Doors",
      "description": "Economical semi water proof flush door for interior applications. Moisture resistant for long life.",
      "price": "₹2,800/piece",
      "thickness": "30mm",
      "size": "Custom sizes available",
      "color": "Natural",
      "features": ["Semi Water Proof", "Economical", "Interior Use", "30mm Thickness"],
      "image": "https://images.jdmagicbox.com/quickquotes/images_main/contemporary-interior-wooden-flush-door-30mm-thickness-803404109-gmhv7eg9.jpg",
      "inStock": true
    },
    {
      "id": 17,
      "name": "Designer Flush Door - 32mm",
      "category": "Flush Doors",
      "description": "Premium designer flush door with decorative patterns. Water proof with elegant finish.",
      "price": "₹4,500/piece",
      "thickness": "32mm",
      "size": "Custom sizes available",
      "color": "Multiple Options",
      "features": ["Designer Pattern", "Water Proof", "Premium Finish", "32mm Thickness"],
      "image": "https://prosteelply.com/wp-content/uploads/2021/07/image_2021_07_14T12_52_16_179Z.png",
      "inStock": true
    },

    // ========================================
    // CHAUGATH PRODUCTS
    // ========================================
    {
      "id": 1,
      "name": "Premium Chaugath Frame - 5×2.5 inch",
      "category": "Chaugath",
      "description": "High density chaugath frame with 25 year guarantee. Termite proof, water proof, and rust free. Perfect for door frames and window frames.",
      "price": "₹450/running ft",
      "thickness": "5×2.5 inch",
      "size": "Height customizable",
      "color": "Natural Wood",
      "features": ["25 Year Guarantee", "Termite Proof", "Water Proof", "Rust Free", "High Density"],
      "image": "https://i.postimg.cc/6pNG1NCB/Grey-Stone-branded-door-design.png",
      "inStock": true
    },
    {
      "id": 2,
      "name": "Premium Chaugath Frame - 6×2.5 inch",
      "category": "Chaugath",
      "description": "Heavy duty chaugath frame with superior strength. 25 year guarantee, termite proof, water proof, rust free construction.",
      "price": "₹550/running ft",
      "thickness": "6×2.5 inch",
      "size": "Height customizable",
      "color": "Natural Wood",
      "features": ["25 Year Guarantee", "Termite Proof", "Water Proof", "Rust Free", "High Density", "Heavy Duty"],
      "image": "https://i.postimg.cc/P5k8Fk1T/Grey-Stone-logo-on-wooden-door.png",
      "inStock": true
    },
    {
      "id": 3,
      "name": "Designer Chaugath Frame",
      "category": "Chaugath",
      "description": "Premium designer chaugath frame with decorative patterns. Height customizable with 25 year guarantee.",
      "price": "₹650/running ft",
      "thickness": "5×2.5 inch / 6×2.5 inch",
      "size": "Height customizable",
      "color": "Teak / Walnut",
      "features": ["25 Year Guarantee", "Termite Proof", "Water Proof", "Rust Free", "Designer Finish"],
      "image": "https://i.postimg.cc/L4DdNSLN/Gemini-Generated-Image-nvy5finvy5finvy5.png",
      "inStock": true
    }
  ]
};